export const DATE_FORMAT_EU = 'dd/MM/yyyy';
export const DATE_FORMAT_EU_DOT = 'dd.MM.yyyy';
export const DATE_FORMAT_EU_LONG = 'dd/MM/yyyy HH:mm';
export const DATE_FORMAT_ISO = 'yyyy-MM-dd';

export const DATE_FORMAT_HOURS_MINUTES = 'HH:mm';
export const TIME_FORMAT_BACKEND = 'HH:mm:ss';

export const DATE_FORMAT_DATEPICKER_LONG = 'yyyy/MM/dd HH:mm:ss';
export const DATE_FORMAT_DATEPICKER_SHORT = 'yyyy/MM/dd';
export const DATE_TIME_FORMAT_WITH_TIMEZONE = "yyyy-MM-dd'T'HH:mm:ssXXX";
